import { Country, Language } from './lists.model';

export class I18nInfo {
  country: Country;

  hasI18n: boolean;

  languageGui: Language;
  // le serialiazer JSON du serveur supprimer le suffixe is...
  languageGuiOrganisationDefault: boolean;

  languagePdf: Language;
  languagePdfOrganisationDefault: boolean;

  // chaines style fr_FR ou en_UK
  languageGuiCode: string;
  languagePdfCode: string;

  // TODO ajout langue par defaut au cas ou chaine manquante ? non : en dur

  // calculé à partir de languageGuiCode
  // chaines style fr ou en
  languageGuiCode_lang_code: string;
  // chaines style FR ou UK
  languageGuiCode_country_code: string;

  languagePdfCode_lang_code: string;
  languagePdfCode_country_code: string;
}
